const imageMimeTest = /^(?:image\/bmp|image\/cis-cod|image\/gif|image\/ief|image\/jpeg|image\/jpeg|image\/jpeg|image\/pipeg|image\/png|image\/svg\+xml|image\/tiff|image\/x-cmu-raster|image\/x-cmx|image\/x-icon|image\/x-portable-anymap|image\/x-portable-bitmap|image\/x-portable-graymap|image\/x-portable-pixmap|image\/x-rgb|image\/x-xbitmap|image\/x-xpixmap|image\/x-xwindowdump)$/i;
const dataUrlParser = /^data:([^,]*),(.*)$/i;
const URL = window.URL || window.webkitURL;

const localImage = {
	isValidImage: function (file) {
		return imageMimeTest.test(file.type);
	},

	parseDataUrl: function (dataUrl) {
		const match = dataUrlParser.exec(dataUrl);

		return {
			spec: match && match[1],
			data: match && match[2]
		};
	},

	create: function (fileOrUrl) {
		return new LocalImage(fileOrUrl); // eslint-disable-line no-use-before-define
	}
};

function LocalImage (fileOrUrl) {
	if (typeof (fileOrUrl) === 'string') {
		this._sourceType = 'dataurl';
	}
	else if (fileOrUrl.name) {
		this._sourceType = 'file';
	}

	this._initPromise = this._getUrl(fileOrUrl);
	this._imagePromise = this._initPromise.then((result) => {
		return this._getImage(result);
	});

	this._dataUrlProvider = () => {
		return this._getDataUrl(fileOrUrl);
	};
}

LocalImage.prototype = {

	getDataUrl: function () {
		return this._dataUrlProvider();
	},

	getImage: function () {
		return this._imagePromise;
	},

	fitToBounds: function (width, height, letterbox) {
		return this.getImage().then(function (img) {
			const canvas = document.createElement('canvas');
			const imageAspect = img.width / img.height;
			const canvasAspect = width / height;
			let size;
			let offset;

			canvas.width = width;
			canvas.height = height;
			const ctx = canvas.getContext('2d');

			ctx!.fillStyle = '#ffffff';
			ctx!.fillRect(0, 0, width, height);
			if (letterbox) {
				size = (imageAspect > canvasAspect) ? {
					width: width,
					height: (width / imageAspect)
				} : {
					width: (height * imageAspect),
					height: height
				};
				offset = (imageAspect > canvasAspect) ? {
					x: 0,
					y: (height - size.height) / 2
				} : {
					x: (width - size.width) / 2,
					y: 0
				};
				ctx!.drawImage(img, 0, 0, img.width, img.height, offset.x, offset.y, size.width, size.height);
			}
			else {
				size = (imageAspect > canvasAspect) ? {
					width: (img.height * canvasAspect),
					height: img.height
				} : {
					width: img.width,
					height: (img.width / canvasAspect)
				};
				offset = (imageAspect > canvasAspect) ? {
					x: (img.width - size.width) / 2,
					y: 0
				} : {
					x: 0,
					y: (img.height - size.height) / 2
				};
				ctx!.drawImage(img, offset.x, offset.y, size.width, size.height, 0, 0, width, height);
			}

			const dataUrl = canvas.toDataURL('image/jpeg', 0.8);

			return dataUrl;
		});
	},

	_getDataUrl: function (fileOrUrl) {
		return new Promise((resolve, reject) => {
			if (this._sourceType === 'dataurl') {
				resolve(fileOrUrl);
			}
			else if (this._sourceType === 'file') {
				if (window.FileReader) {
					const reader = new window.FileReader();

					reader.onload = function () {
						resolve(reader.result);
					};
					reader.readAsDataURL(fileOrUrl);
				}
				else {
					reject(new Error('Local image processing is not supported by this browser.'));
				}
			}
			else {
				reject(new Error('Invalid or missing image.'));
			}
		});
	},

	_getUrl: function (fileOrUrl) {
		if (this._sourceType === 'file') {
			return new Promise((resolve) => {
				resolve(URL.createObjectURL(fileOrUrl));
			});
		}
		return this._getDataUrl();
	},

	_getImage: function (url) {
		const sourceType = this._sourceType;
		const revoke = () => {
			if (sourceType === 'file') {
				URL.revokeObjectURL(url);
			}
		};

		return new Promise((resolve, reject) => {
			const img = new window.Image();

			img.onload = () => {
				revoke();
				resolve(img);
			};
			img.onerror = () => {
				reject(new Error('Failed to load ' + url));
			};

			img.src = url;
		});
	}
};

export default localImage;